import { Box, Button, Drawer, Typography, styled } from '@mui/material'

export const TitleNav = styled(Typography)(({ theme }) => ({
  height: 'inherit',
  width: 'auto',
  [theme.breakpoints.up('sm')]: {
    height: 24,
    position: 'relative',
    top: '-1px',
    marginRight: '32px'
  }
}))

export const GlobalButtonAdd = styled(Button)({
  padding: 4,
  marginRight: 20,
  minWidth: 48,
  borderRadius: 4
})

export const ContainerActions = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(52, 54, 56, 0.73)',
  backdropFilter: 'blur(15px)',
  borderRadius: '10px',
  '& .MuiListItemIcon-root': {
    minWidth: 'auto',
    marginRight: ' 6px',
    color: theme.palette.grey[100]
  },
  '& .MuiMenuItem-root': {
    height: 56,
    alignItems: 'center',
    color: theme.palette.grey[100],
    fontSize: 16,
    justifyContent: 'center',
    borderBottom: `1px solid ${theme.palette.grey[100]}`
  },
  [theme.breakpoints.down('md')]: {
    '& li:last-child': {
      borderBottom: 'none',
      color: theme.palette.error.main
    },
    '&.filter': {
      '& li:last-child': {
        color: theme.palette.grey[100]
      }
    }
  }
}))

export const DropdownActions = styled(Drawer)(({ theme }) => ({
  paper: {
    backgroundColor: 'transparent',
    marginBottom: 92,
    width: 180,
    borderRadius: '10px',
    [theme.breakpoints.down('md')]: {
      width: '100vw'
    }
  }
}))
